// serviceWorkerRegistration.js
export function register(config) {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            navigator.serviceWorker.register(swUrl).then(registration => {
                // Проверяем обновления сразу после регистрации
                registration.update().catch(() => {});

                // Проверяем обновления каждые 1 час (можно настроить интервал)
                setInterval(() => {
                    registration.update().catch(() => {});
                }, 60 * 60 * 1000);

                registration.onupdatefound = () => {
                    const installingWorker = registration.installing;
                    if (installingWorker == null) return;

                    installingWorker.onstatechange = () => {
                        if (installingWorker.state === 'installed') {
                            if (navigator.serviceWorker.controller) {
                                // Новый контент доступен
                                if (config && config.onUpdate) {
                                    config.onUpdate(registration);
                                }
                            } else {
                                // Контент закэширован впервые
                                if (config && config.onSuccess) {
                                    config.onSuccess(registration);
                                }
                            }
                        }
                    };
                };
            }).catch(error => {
                console.error('Ошибка регистрации SW:', error);
            });
        });
    }
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            registration.unregister();
        });
    }
}